import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CircleQuestionMarkOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CircleQuestionMarkOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor">
        <path d="M11 15.5v2h2v-2h-2ZM11 11.71V14h2v-.81c1.94-.73 3-1.97 3-3.55A3.7 3.7 0 0 0 12.25 6c-1.72 0-3.22 1.1-3.64 2.66l1.93.51c.18-.68.9-1.17 1.71-1.17C13.33 8 14 8.85 14 9.64c0 1.06-1.42 1.62-2.27 1.86l-.73.21Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1Zm0 2c4.96 0 9 4.04 9 9s-4.04 9-9 9-9-4.04-9-9 4.04-9 9-9Z" />
      </g>
    </svg>;
}) as ForwardedIconComponent);
export default CircleQuestionMarkOutlined;